import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Search } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, CTABand } from "@/components/blocks";
import api from "@/lib/api";

export default function BrandsHub() {
  const [brands, setBrands] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/seo/brands").then(({ data }) => setBrands(data)); }, []);
  const list = brands.filter((b) => b.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="brands-hub-page">
      <Seo title="Reprogrammation moteur par marque : Audi, BMW, Mercedes, Volkswagen… | Horsepower Garage"
        description="Reprogrammation moteur Stage 1, Stage 2 et conversion E85 pour 108 marques et plus de 9 800 motorisations. Gains de puissance mesurés au banc dans nos 6 centres Horsepower en France."
        canonical="https://www.horsepowergarage.fr/reprogrammation-moteur" image="/photos/hero-beziers.jpg" />
      <PageHero eyebrow="Toutes les marques" title="Reprogrammation moteur par marque"
        subtitle="108 marques, 9 899 motorisations : retrouvez les gains Stage 1, Stage 2 et E85 de votre véhicule, validés au banc de puissance." image="/photos/hp-4199.webp" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="relative max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une marque…" className="w-full bg-hp-dark border border-white/10 pl-9 pr-3 py-3 text-sm text-white focus:outline-none focus:border-hp-yellow" data-testid="brands-search" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mt-8" data-testid="brands-grid">
          {list.map((b, i) => (
            <Reveal key={b.slug} delay={(i % 4) * 0.03}>
              <Link to={`/reprogrammation-moteur/${b.slug}`} className="hp-card p-4 flex items-center gap-3 hover:border-hp-yellow/50 transition-colors group h-full" data-testid={`brand-link-${b.slug}`}>
                {b.logo && <span className="h-11 w-11 bg-white rounded-sm flex items-center justify-center shrink-0 p-1"><img src={b.logo} alt="" className="max-h-full max-w-full object-contain" loading="lazy" /></span>}
                <span className="min-w-0">
                  <span className="block font-display font-bold uppercase tracking-tight text-sm truncate group-hover:text-hp-yellow">{b.name}</span>
                  <span className="block text-[11px] text-neutral-500">{b.models} modèles · {b.count} motorisations{b.max_gain > 0 ? ` · jusqu'à +${b.max_gain} ch` : ""}</span>
                </span>
                <ArrowRight size={14} className="ml-auto text-neutral-600 group-hover:text-hp-yellow shrink-0" />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
